import React from 'react';
import Icon from 'components/AppIcon';

export default function HUDOverlay({ score, lives, level, timeLeft, achievements }) {
  const isLowTime = timeLeft < 30;

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-1 py-2">
      {/* Score */}
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg" style={{ background: 'rgba(99,102,241,0.15)', border: '1px solid rgba(99,102,241,0.3)' }}>
        <Icon name="Star" size={16} color="var(--color-accent)" />
        <span className="font-data text-sm font-semibold" style={{ color: 'var(--color-foreground)' }}>
          {score?.toLocaleString()}
        </span>
      </div>
      {/* Lives */}
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg" style={{ background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.3)' }}>
        {Array.from({ length: 3 })?.map((_, i) => (
          <Icon
            key={i}
            name="Heart"
            size={16}
            color={i < lives ? '#ef4444' : 'rgba(239,68,68,0.2)'}
            strokeWidth={i < lives ? 2 : 1}
          />
        ))}
      </div>
      {/* Level */}
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg" style={{ background: 'rgba(16,185,129,0.12)', border: '1px solid rgba(16,185,129,0.3)' }}>
        <Icon name="Layers" size={16} color="var(--color-success)" />
        <span className="font-caption text-xs font-semibold" style={{ color: 'var(--color-success)' }}>
          LVL {level}
        </span>
      </div>
      {/* Timer */}
      <div
        className="flex items-center gap-2 px-3 py-1.5 rounded-lg transition-all"
        style={{
          background: isLowTime ? 'rgba(239,68,68,0.15)' : 'rgba(245,158,11,0.12)',
          border: `1px solid ${isLowTime ? 'rgba(239,68,68,0.4)' : 'rgba(245,158,11,0.3)'}`,
        }}
      >
        <Icon name="Clock" size={16} color={isLowTime ? 'var(--color-error)' : 'var(--color-warning)'} />
        <span
          className={`font-data text-sm font-semibold ${isLowTime ? 'animate-pulse' : ''}`}
          style={{ color: isLowTime ? 'var(--color-error)' : 'var(--color-warning)' }}
        >
          {String(Math.floor(timeLeft / 60))?.padStart(2, '0')}:{String(timeLeft % 60)?.padStart(2, '0')}
        </span>
      </div>
      {/* Achievement pop */}
      {achievements?.length > 0 && (
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg" style={{ background: 'rgba(99,102,241,0.2)', border: '1px solid rgba(99,102,241,0.5)' }}>
          <Icon name="Trophy" size={16} color="var(--color-accent)" />
          <span className="font-caption text-xs font-semibold" style={{ color: 'var(--color-accent)' }}>
            {achievements?.[achievements?.length - 1]}
          </span>
        </div>
      )}
    </div>
  );
}